module.exports = __webpack_public_path__ + "static/img/banner_2.15751eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdAnniversary/3/banner_2.png
// module id = MSOp
// module chunks = 2